<template>
    <div class="dorw-down" @click.stop :style="{width:inputWh}">
        <div class="select-text" @click="openOption">
			<button class="btn" :class="className">{{name}}</button>
        </div>
        <ul class="option" v-show="show" :style="{width:optionWh}">
            <slot></slot>
        </ul>
    </div>
</template>
<script>
export default {
    name: "drowDown",
    props: {
		value:{
			type: String
        },
		inputWh:{
			type: String,
			default: 'auto',
        },
        className:{
            type: String,
			default: 'btn-none',
        },
		optionWh:{
			type: String,
			default: '140%',
		}
    },
    data() {
        return {
            show:false,
            index:'',
			myValue: this.value,
			name:''
        }
    },
	watch: {
	    //监听prop传的value，如果父级有变化了，将子组件的myValue也跟着变，达到父变子变的效果
	    value(newVal) {
            this.myValue = newVal
	    },
	    //监听myValue，如果子组件中的内容变化了，通知父级组件，将新的值告诉父级组件，我更新了，父级组件接受到值后页就跟着变了
	    // myValue(newVal) {
        //     console.log(newVal+'#');
	        
	    // }
	},
    mounted() {
        
    },
    created() {
		this.ready();
    },
    methods: {
        ready() {
            document.addEventListener('click', (e) => {
                if (!this.$el.contains(e.target)) this.show = false
            })
        },
        openOption(){
            this.show = !this.show;
            document.addEventListener('click',this.hideSel,true)
        },
        hideSel(e){
            if(this.$el.contains(e.target)){
                // e.stopPropagation();
                setTimeout(() => {
                    this.$emit('input', this.myValue)
                    this.$emit('confirmOption',this.myValue)
                }, 1);
            }else{
                this.show = false;　　// 如果是子元素,则阻止事件捕获
            }
            document.removeEventListener('click',this.hideSel,true)
        }
	}
}
</script>
<style lang="" scope>
    .dorw-down{position:relative;min-width:55px;display:inline-block;}
	.dorw-down .btn{width:100%;padding-right:32px;}
    .select-text{position:relative;width:100%;}
    /* .select-text .input-text{height:32px;} */
    .select-text:after{content:'';width:0;height:0;position:absolute;top:50%;right:12px;margin-top:-2px;border-right:4px solid transparent;border-left:4px solid transparent;border-top:4px solid #fff;}
    .select-text:before{content:'';width:0;height:0;position:absolute;top:50%;right:10px;margin-top:-2px;border-right:6px solid transparent;border-left:6px solid transparent;border-top:6px solid #666;}
    .option{width:100%;position:absolute;top:34px;left:0;background:#fff;border:1px solid #ddd;z-index:99;}
    .option li{padding:0 10px;line-height:32px;}
    .option li:hover{background:rgba(10,92,244,.1);}
</style>



// WEBPACK FOOTER //
// src/components/form/drowDown/drowDown.vue